export class BeException extends Error {

  // Make sure this is hard-coded as a string
  // BeException.name will not work in production
  // because class names are changed when minified
  className: string = 'BeException';
  code: number | undefined;
  prev: Error | undefined;

  constructor(message?: string, code?: number, prev?: any) {
    super(message);
    if ((Error as any).captureStackTrace !== undefined) {
      (Error as any).captureStackTrace(this, this.constructor);
    };
    this.name = this.constructor.name;
    this.code = code;
    this.prev = prev;
  }
}

export class AuthException extends BeException {

  className: string = 'AuthException';

  constructor(message?: string, code?: number, prev?: any) {
    super(message || 'Access denied', code, prev);
  }
}

export class AccessDeniedException extends BeException {

  className: string = 'AccessDeniedException';

  constructor(message?: string, code?: number, prev?: any) {
    super(message || 'Access denied', code, prev);
  }
}

export class NotFoundException extends BeException {

  className: string = 'NotFoundException';

  constructor(message?: string, code?: number, prev?: any) {
    super(message || 'Resource not found', code, prev);
  }
}

export class BadRequestException extends BeException {

  className: string = 'BadRequestException';

  constructor(message?: string, code?: number, prev?: any) {
    super(message || 'Bad request', code, prev);
  }
}

export class ValidationException extends BadRequestException {

  className: string = 'ValidationException';

  fields: any;

  constructor(message?: string, fields?: any) {
    super(message);
    this.fields = fields;
  }
}

export class ServerErrorException extends BeException {

  className: string = 'ServerErrorException';

  constructor(message?: string, code?: number, prev?: any) {
    super(message || 'Internal server error', code, prev);
  }
}

export class LocalException extends Error {

  className: string = 'LocalException';
  code: number | undefined;
  prev: Error | undefined;

  constructor(message?: string, code?: number, prev?: any) {
    super(message);
    if ((Error as any).captureStackTrace !== undefined) {
      (Error as any).captureStackTrace(this, this.constructor);
    };
    this.name = this.constructor.name;
    this.code = code;
    this.prev = prev;
  }
}

export class NetworkErrorException extends LocalException {

  className: string = 'NetworkErrorException';

  constructor(message?: string, code?: number, prev?: any) {
    super(message || 'Network error', code, prev);
  }
}

export const ACC_TOKEN_MISSING = 1000;
export const ACC_TOKEN_JWT_EXPIRED = 1002;
export const REF_TOKEN_NOT_FOUND = 1007;
export const REF_TOKEN_EXPIRED = 1009;
export const UNABLE_SEND_NEW_ORDER_CUSTOMER_NOTIF = 1041;
export const UNABLE_SEND_NEW_ORDER_DEALER_NOTIF = 1042;
export const UNABLE_SEND_UPLOADED_DOCS_NOTIF = 1047;
